import superagent from 'superagent';
import { LogOut, getAuthorizationToken } from 'utils';
import ConfigPath from 'configpath';

export const request = superagent.agent().use((req) => {
  req.on('response', (res) => {
    let bearerToken = res?.headers?.[ConfigPath.TOKEN_KEY_INFO];
    if (bearerToken) {
      if (bearerToken?.toLowerCase()?.startsWith('bearer')) {
        bearerToken = bearerToken.replace(/^Bearer\s+/i, '');
      }
      localStorage.setItem(ConfigPath.TOKEN_KEY_INFO, bearerToken);
    }
    // intercept all the responce error
    if (res.status === 401) {
      LogOut(true);
    }
  });
  req.on('error', (error) => {
    // intercept all the responce error
    if (error.status === 401) {
      LogOut(true);
    }
  });
});

class Https {
  static get(url, headers = {}, isNoCors = false) {
    const token = getAuthorizationToken(ConfigPath.TOKEN_KEY_INFO);
    const requestHeaders = {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
      'Cache-Control': 'no-cache',
    };
    if (isNoCors) {
      return request.get(url).set(requestHeaders);
    }
    return request.get(url).set(requestHeaders);
  }

  static post(url, data = {}, headers = {}, isNoCors = false) {
    const token = getAuthorizationToken(ConfigPath.TOKEN_KEY_INFO);
    const requestHeaders = {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
      'Cache-Control': 'no-cache',
    };
    if (isNoCors) {
      return request.post(url).send(data).set(requestHeaders);
    }
    return request.post(url).send(data).set(requestHeaders);
  }

  static put(url, data = {}, headers = {}, isNoCors = false) {
    const token = getAuthorizationToken(ConfigPath.TOKEN_KEY_INFO);
    const requestHeaders = {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
      'Cache-Control': 'no-cache',
    };
    if (isNoCors) {
      return request.put(url).send(data).set(requestHeaders);
    }
    return request.put(url).send(data).set(requestHeaders);
  }

  static delete(url, data = {}, headers = {}, isNoCors = false) {
    const token = getAuthorizationToken(ConfigPath.TOKEN_KEY_INFO);
    const requestHeaders = {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
      'Cache-Control': 'no-cache',
    };
    if (isNoCors) {
      return request.delete(url).send(data).set(requestHeaders);
    }
    return request.delete(url).send(data).set(requestHeaders);
  }
}

export default Https;
